module.exports = __webpack_public_path__ + "static/media/Soraka.e3925977.png";